import { fetcherIts, STATUS_OK } from "libs/fetcher";
import { ISosCdrIndexParams, ISosCdrIndexResponse, ISosStatsIndexParams, ISosStatsIndexResponse } from "models/Cdr";

export const indexSosCdr = async ({ page, pageSize, startDate, endDate, src, dst, assetId, disposition }: ISosCdrIndexParams): Promise<ISosCdrIndexResponse> => {
    const url = `/issabel/cdr`;
    let response: ISosCdrIndexResponse = { data: [], totalItems: 0, error: true };

    try {
        const fetchResponse = await fetcherIts({
            url,
            method: 'GET',
            params: { page, pageSize, startDate, endDate, src, dst, assetId, disposition }
        });

        if (fetchResponse === undefined) {
            throw new Error('Request failed');
        }
        const { fetch } = fetchResponse;

        console.log("🚀 ~ file: pmv.ts:22 ~ indexSosCdr ~ fetch:", fetch)

        if (typeof fetch === 'string') {
            throw "Error al recibir la respuesta";
        } else if (fetch instanceof Object) {
            if ('status' in fetch && fetch.status === STATUS_OK) {
                const responseData = 'data' in fetch ? fetch.data : null;
                if (Array.isArray(responseData.data)) {
                    response.data = responseData.data;
                    response.error = false;
                    response.totalItems = responseData.totalItems;
                }
            }
        }

        return response;
    } catch (error) {
        return response;
    }
}

export const indexSosStats = async ({ }: ISosStatsIndexParams): Promise<ISosStatsIndexResponse> => {
    const url = `/issabel/stats`;
    let response: ISosStatsIndexResponse = { data: [], error: true };

    try {
        const fetchResponse = await fetcherIts({
            url,
            method: 'GET'
        });

        if (fetchResponse === undefined) {
            throw new Error('Request failed');
        }
        const { fetch } = fetchResponse;
        
        console.log("🚀 ~ sos.ts:55 ~ indexSosStats ~ fetch:", fetch)

        if (typeof fetch === 'string') {
            throw "Error al recibir la respuesta";
        } else if (fetch instanceof Object) {
            if ('status' in fetch && fetch.status === STATUS_OK) {
                const responseData = 'data' in fetch ? fetch.data : null;
                if (Array.isArray(responseData.data)) {
                    response.data = responseData.data;
                    response.error = false;
                }
            }
        }

        return response;
    } catch (error) {
        return response;
    }
}